// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__4mxFQ","calendarButtons":"ClockData_calendarButtons__uZBaO"};